import { NgClass, SlicePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { BetBuilderRowOfOptions, OptionGroup2 } from '@frontend/sports/betting-offer/feature/model';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';
import { RxFor } from '@rx-angular/template/for';

import { BetBuilderOptionComponent } from './bet-builder-option.component';
import { MarketHelpComponent } from './market-help/market-help.component';
import { SpreadOptionGroupComponent } from './spread-option-group.component';

@Component({
    selector: 'ms-bet-builder-spread-option-group',
    templateUrl: './bet-builder-spread-option-group.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RxFor, NgClass, SlicePipe, MarketHelpComponent, BetBuilderOptionComponent, IconCustomComponent],
})
export class BetBuilderSpreadOptionGroupComponent extends SpreadOptionGroupComponent {
    isSingleRowOfOptions = () => this.optionGroups.length === BetBuilderRowOfOptions.Single;

    protected override updateOptionAttr(): void {
        this.optionGroups.forEach((group: OptionGroup2) => {
            if (group.options.length === 1) {
                const index = group.options[0]!.optionAttribute === this.firstParticipant ? 1 : 0;
                group.options.splice(index, 0, undefined);
            }
        });
    }

    protected override setParticipants(): void {
        this.optionGroups.forEach((group: OptionGroup2) => {
            if (group.options.length === 2) {
                this.firstParticipant = group.options[0]!.optionAttribute!;
                this.secondParticipant = group.options[1]!.optionAttribute!;

                return;
            }
        });
    }
}
